export const UOM_OPTIONS = [
  {
    value: "pump",
    label: "Pump",
  },
  {
    value: "tbs",
    label: "Tablespoon",
  },
  {
    value: "wedge",
    label: "Wedge",
  },
  {
    value: "single",
    label: "Single",
  }
]